export const menuItem = [
  {
    id: 1,
    label: "About Quantum",
    items: [
      {
        id: 1,
        label: "Overview",
        path: "/about-us",
      },
      {
        id: 2,
        label: "Our History",
        path: "/history",
      },
      {
        id: 3,
        label: "Our People",
        path: "/our-people",
      },
      // {
      //   id: 4,
      //   label: "Contact Us",
      //   path: "/contact-us",
      // },
      // {
      //   id: 5,
      //   label: "Our Services",
      //   path: "/our-services",
      // },
    ],
  },
  {
    id: 2,
    label: "Services",
    items: [
      {
        id: 1,
        label: "Overview",
        path: "/our-services",
      },
      {
        id: 2,
        label: "For Investor",
        path: "/investor-services",
      },
      {
        id: 3,
        label: "For Developers",
        path: "/developer-services",
      },
      {
        id: 4,
        label: "For Others",
        path: "/other-services",
      },
      //  {
      //   id: 5,
      //   label: "Our Clients",
      //   path: "/contact-us",
      // },
      {
        id: 5,
        label: "Contact Us",
        path: "/contact-us",
      },
    ],
  },
  {
    id: 3,
    label: "Impact",
    items: [
      // {
      //   id: 1,
      //   label: "Community Impact",
      //   path: "/community_impect",
      // },
      {
        id: 2,
        label: "Social Responsibility",
        path: "/social_responsibility",
      },
    ],
  },
  // {
  //   id: 3,
  //   label: "Social",
  //   items: [
  //     {
  //       id: 1,
  //       label: "Social Responsibility",
  //       path: "/social_responsibility",
  //     },
  //     {
  //       id: 2,
  //       label: "Clients",
  //       path: "/clients",
  //     },
  //   ],
  // },
  {
    id: 4,
    label: "Insights & Updates",
    items: [
      {
        id: 1,
        label: "Insights",
        path: "/insights",
      },
    ],
  },
  {
    id: 5,
    label: "Projects",
    items: [
      {
        id: 1,
        label: "Project Listing",
        path: "/project-listing",
      },
    ],
  },
  {
    id: 6,
    label: "Clients",
    items: [
      {
        id: 1,
        label: "Clients",
        path: "/clients",
      },
    ],
  },
  {
    id: 7,
    label: "Job Postings",
    items: [
      {
        id: 1,
        label: "Current Job Postings",
        path: "/careers",
      },
    ],
  },
];

export const responsiveSliderOptions = [
  {
    breakpoint: "1400px",
    numVisible: 3,
    numScroll: 1,
  },
  {
    breakpoint: "1199px",
    numVisible: 3,
    numScroll: 1,
  },
  {
    breakpoint: "768px",
    numVisible: 1,
    numScroll: 1,
  },
  {
    breakpoint: "575px",
    numVisible: 1,
    numScroll: 1,
  },
];
